<div class="d-flex align-items-center p-3">
  @if ((activeRoute$ | async) !== 'MainUserMenu') {
  <button
    class="btn btn-round btn-light mr-2"
    (click)="back()"
    data-e2e="user-menu-back"
  >
    <fa-icon [icon]="['fas', 'angle-left']"></fa-icon>
  </button>
  }
  <h4 data-e2e="user-menu-header" class="m-0 font-weight-bold">
    {{ header$ | async }}
  </h4>
  <epc-language-selector
    class="language-selector ml-auto"
  ></epc-language-selector>
  <button
    class="btn btn-round btn-light ml-3"
    (click)="handleClose()"
    data-e2e="user-menu-close"
  >
    <fa-icon [icon]="['fas', 'xmark']" size="xs"></fa-icon>
  </button>
</div>

<div
  class="flex-grow-1 d-flex flex-column overflow-auto menu-route-wrapper-content"
>
  @switch (activeRoute$ | async) { @case ('MainUserMenu') {
  <epc-user-menu (closeMenu)="handleClose()"></epc-user-menu>
  } @case ('ChangePassword') {
  <epc-change-password></epc-change-password>
  } @case ('AssortmentManager') {
  <epc-assortment-manager class="mx-3"></epc-assortment-manager>
  } @case ('UserAccounts') {
  <epc-account-selector-menu
    class="d-flex flex-column flex-grow-1"
    (closeMenu)="handleClose()"
  ></epc-account-selector-menu>
  <div class="pl-3 pr-3 pb-3">
    <button
      type="button"
      (click)="back()"
      data-e2e="cancel-btn"
      i18n="Accounts|Cancel text@@cancel"
      class="btn btn-light btn-block"
    >
      Cancel
    </button>
  </div>
  } @case ('UserContacts') {
  <epc-user-contacts-wrapper></epc-user-contacts-wrapper>
  } @case ('BasketManager') {
  <epc-switch-basket></epc-switch-basket>
  } @case ('BusinessContacts') {
  <epc-searchable-business-contacts></epc-searchable-business-contacts>
  } }
</div>
